module.exports = __webpack_public_path__ + "img/gift-02.f5804d03.svg";